module.exports = __webpack_public_path__ + "img/header-background.0371c05.jpg";